import babyDoll from './babydoll.svg'
import camilloAC from './camilloac.svg'
import carib from './carib.svg'
import clarkesCourt from './clarkescourt.svg'
import cocaCola from './cocacola.svg'
import dasani from './dasani.svg'
import demolitionSounds from './demolitionsounds.svg'
import feelFreePromo from './feelfree.svg'
import powerFM from './powerfm.svg'
import sugarNSpice from './sugarnspice.svg'



export const brands = [
	{
		src: feelFreePromo,
		alt: 'Feel Free Promotions',
		href: '#',
	},
	{
		src: demolitionSounds,
		alt: 'Demolition Sounds',
		href: '#',
	},
	{
		src: powerFM,
		alt: 'PowerFM',
		href: '#',
	},
	{
		src: babyDoll,
		alt: 'Baby Doll',
		href: '#',
	},
	{
		src: camilloAC,
		alt: 'Camillo',
		href: '#',
	},
	{
		src: sugarNSpice,
		alt: 'SugarNSpice',
		href: '#',
	},

]


